import {FC, useEffect, useState} from 'react'
import Category from "../Options/Category";
import {storeBooking} from "../../lib/booking";
import {formatNumber} from "../../lib/helpers";

interface Props {
    booking: Booking
    setBooking: Function,
    tireCount: number,
    data: any
}

const HjulskifteTireOfferTire: FC<Props> = ({ booking, setBooking, data, tireCount }) => {
    const [quantity, setQuantity] = useState(tireCount)
    let className = booking.hjulskifte.options.product_id === data.id ? 'button tire_option_add_to_cart_button added' : 'button tire_option_add_to_cart_button'

    const updateField = (e: any) => {
        switch (e.target.name) {
            case 'quantity':
                setQuantity(parseInt(e.target.value))
                if(booking.hjulskifte.options.product_id === data.id) {
                    booking.hjulskifte.options.quantity = parseInt(e.target.value)
                    booking.hjulskifte.options.name = data.name + ' x ' + e.target.value + ' (inkl. montering)'
                    booking.hjulskifte.options.price = (parseInt(data.price) * e.target.value) + (booking.hjulskifte.assembly_price * e.target.value)
                    storeBooking(booking, setBooking)
                }
                break;
            case 'add_to_cart':
                if(booking.hjulskifte.options.product_id === data.id) {
                    booking.hjulskifte.options.product_id = null // remove from cart
                }else {
                    booking.hjulskifte.options.product_id = e.target.value
                    booking.hjulskifte.options.quantity = quantity
                    booking.hjulskifte.options.name = data.name + ' x ' + quantity + ' (inkl. montering)'
                    booking.hjulskifte.options.price = (parseInt(data.price) * quantity) + (booking.hjulskifte.assembly_price * quantity)
                }
                storeBooking(booking, setBooking)
                break;
        }
    }

    return (
        <li className="product">
            <div className="wco-info">
                <i className="far fa-info-circle" aria-hidden="true"/>
                <div className="wco-info-tooltip">
                    <h6>{data.tooltip}</h6>
                    <p dangerouslySetInnerHTML={data.content}/>
                </div>
            </div>
            <div className="price-visible">
                <img src={data.image} alt={data.name}/>
                <h2 className="woocommerce-loop-product__title">{data.name}</h2>
                <span className="price">
                    <span className="woocommerce-Price-amount amount">{formatNumber(data.price)} kr/däck</span>
                    <p>Inkl. moms. <b>399 kr</b> tillkommer per däck för montering, balansering och miljöavgift.</p>
                </span>
                <div className="quantity">
                    <select name="quantity" id={data.id} value={quantity} onChange={updateField}>
                        <option value="2">2</option>
                        <option value="4">4</option>
                    </select>
                </div>
                <button name={'add_to_cart'} value={data.id} onClick={updateField} className={className}
                        rel="nofollow">Välj
                </button>
            </div>
        </li>
    )
};

export default HjulskifteTireOfferTire
